"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnchorManual = exports.isAnchorP2P = exports.isAnchorLocationGPS = exports.isFileData = exports.isCaptureData = exports.isLink = exports.isHeightProviderManual = exports.isHeightPhotomeasureManualProvider = exports.isHeightPhotomeasureProvider = exports.isHeightSpanHeightProvider = exports.isVectorProviderManual = exports.isVectorCollectionProvider = exports.isVectorPointToPointProvider = exports.isVerticalSeparationDrawable = exports.isMaskDrawable = exports.isLineDrawable = exports.isMarkerDrawable = exports.isHiddenImageVisibility = exports.isGammaBrightnessCorrection = exports.isFreeCropParameter = void 0;
exports.findObjectsWhere = findObjectsWhere;
const core_api_1 = require("@ikegps/core-api");
const isFreeCropParameter = (o) => o.tag === 'free';
exports.isFreeCropParameter = isFreeCropParameter;
const isGammaBrightnessCorrection = (o) => o.tag === 'gamma';
exports.isGammaBrightnessCorrection = isGammaBrightnessCorrection;
const isHiddenImageVisibility = (o) => o.tag === 'hidden';
exports.isHiddenImageVisibility = isHiddenImageVisibility;
const isMarkerDrawable = (o) => o.tag === core_api_1.DrawableTag.MARKER || o.tag === core_api_1.DrawableTag.OFFSET;
exports.isMarkerDrawable = isMarkerDrawable;
const isLineDrawable = (o) => o.tag === core_api_1.DrawableTag.LINE;
exports.isLineDrawable = isLineDrawable;
const isMaskDrawable = (o) => o.tag === core_api_1.DrawableTag.MASK;
exports.isMaskDrawable = isMaskDrawable;
const isVerticalSeparationDrawable = (o) => o.tag === core_api_1.DrawableTag.VERTICAL_SEPARATION;
exports.isVerticalSeparationDrawable = isVerticalSeparationDrawable;
const isVectorPointToPointProvider = (fieldData) => fieldData.provider === 'pointtopoint';
exports.isVectorPointToPointProvider = isVectorPointToPointProvider;
const isVectorCollectionProvider = (fieldData) => fieldData.provider === 'collection';
exports.isVectorCollectionProvider = isVectorCollectionProvider;
const isVectorProviderManual = (fieldData) => fieldData.provider === 'manual';
exports.isVectorProviderManual = isVectorProviderManual;
const isHeightSpanHeightProvider = (fieldData) => fieldData.provider === 'spanheight';
exports.isHeightSpanHeightProvider = isHeightSpanHeightProvider;
const isHeightPhotomeasureProvider = (fieldData) => fieldData.provider === 'photomeasure';
exports.isHeightPhotomeasureProvider = isHeightPhotomeasureProvider;
const isHeightPhotomeasureManualProvider = (fieldData) => fieldData.provider === 'photomeasuremanual';
exports.isHeightPhotomeasureManualProvider = isHeightPhotomeasureManualProvider;
const isHeightProviderManual = (fieldData) => fieldData.provider === 'manual';
exports.isHeightProviderManual = isHeightProviderManual;
const isLink = (fieldData) => fieldData.provider === 'collection';
exports.isLink = isLink;
const isCaptureData = (object) => object.camera != null && object.camera.imageuuid != null;
exports.isCaptureData = isCaptureData;
const isFileData = (object) => object.attachmentId != null && object.size != null;
exports.isFileData = isFileData;
const isAnchorLocationGPS = (object) => object.value.collectionTool === 'LOCATION' && object.provider === 'gps';
exports.isAnchorLocationGPS = isAnchorLocationGPS;
const isAnchorP2P = (object) => object.value.collectionTool === 'VECTOR' && object.provider === 'pointtopoint';
exports.isAnchorP2P = isAnchorP2P;
const isAnchorManual = (object) => object.value.collectionTool === 'VECTOR' && object.provider === 'manual';
exports.isAnchorManual = isAnchorManual;
function findObjectsWhere(data, pred) {
    if (pred(data)) {
        return [data];
    }
    let found = [];
    for (const key of Object.keys(data)) {
        const value = data[key];
        if (value && typeof value === 'object') {
            found = found.concat(findObjectsWhere(value, pred));
        }
    }
    return found;
}
//# sourceMappingURL=collection.model.util.js.map